export const USERS: User[] = [
  {
    user_id: 0,
    username: "producer_san",
    display_name: "Anzu!",
    description: "ES's hardworking producer!",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/v1688828994/hold-hands-icons/anzu_icon.png"
  },
  {
    user_id: 1,
    username: "THRILLADDICT",
    display_name: "RINNE 🎲",
    description: "leader of the bees",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_142,y_34/v1689777108/hold-hands-icons/rinne_twt_icon.png"
  },
  {
    user_id: 2,
    username: "loveswan",
    display_name: "💖 aira!! 💖",
    description: "alkaloid's heart! I LOVE~! ♡",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/v1689778444/hold-hands-icons/aira_twt_icon.png"
  },
  {
    user_id: 3,
    username: "yummytummylover",
    display_name: "niki!",
    description: "chori~su! would you like something to eat?",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_185,y_23/v1689779474/hold-hands-icons/niki_twt_icon.png"
  },
  {
    user_id: 4,
    username: "cosprosvice",
    display_name: "Saegusa Ibara",
    description: "Salute!",
    account_created: "2020-02-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_164,y_42/v1689779811/hold-hands-icons/ibara_twt_icon.png"
  },
  {
    user_id: 5,
    username: "hiiroamagi",
    display_name: "♠ Hiiro ♠",
    description: "Alkaloid's spade! Nice to meet you!",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_127/v1689780394/hold-hands-icons/hiiro_twt_icon.png"
  },
  {
    user_id: 6,
    username: "sazanami",
    display_name: "🌊 Jun",
    description: "Eden + Eve",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_244/v1689783930/hold-hands-icons/jun_twt_icon.png"
  },
  {
    user_id: 7,
    username: "sakuraoukawa",
    display_name: "🌸",
    description: "Crazy:B & Double Face",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_162/v1689805662/hold-hands-icons/kohaku_twt_icon.png"
  },
  {
    user_id: 8,
    username: "HiMERU",
    display_name: "",
    description: "The secret hidden in your heart.",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_227,y_44/v1689805662/hold-hands-icons/himeru_twt_icon.png"
  },
  {
    user_id: 9,
    username: "fantasticdays",
    display_name: "II HIYORI ☀️",
    description: "",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_113/v1689806511/hold-hands-icons/hiyori_twt_icon.png"
  },
  {
    user_id: 10,
    username: "HOWLINGWOLF",
    display_name: "KOGA 🐺",
    description: "Sharpened Claws, Bared Fangs! It's Wolf Rock!",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_302/v1689810062/hold-hands-icons/koga_twt_icon.png"
  },
  {
    user_id: 11,
    username: "rannagisa",
    display_name: "Nagisa Ran",
    description: "",
    account_created: "2020-03-01 00:00:00",
    icon_url: "https://res.cloudinary.com/df2zvtnjc/image/upload/c_crop,h_300,w_300,x_229/v1689860302/hold-hands-icons/nagisa_twt_icon.png"
  }
]